import {Component, Input} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {ExamSessionService} from "../../../shared/services/exam-session/exam-session.service";
import {ExamSession} from "../../../shared/models/examSession";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {take} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";


@Component({
    selector: "app-session-incident-modal",
    templateUrl: "./session-incident-modal.component.html",
    styleUrls: ["./session-incident-modal.component.scss"]
})
export class SessionIncidentModalComponent {

    @Input() examSession: ExamSession;
    submitting: boolean = false;
    form: FormGroup = new FormGroup({
        comment: new FormControl("")
    });

    constructor (
        public activeModal: NgbActiveModal,
        private examSessionService: ExamSessionService,
        private toastr: ToastrService
    ) {}

    submit () {
        this.submitting = true;

        const {comment} = this.form.value;

        this.examSessionService.reportIncident(this.examSession.id, comment).pipe(take(1)).
            subscribe(
                (res: ExamSession) => {
                    this.submitting = false;
                    this.activeModal.close(res);
                },
                (err) => {
                    if (err.status === 597) {
                        this.toastr.error(
                            "Attention ! l'email de notification n'a pas pu être envoyé",
                            "Incident signalé"
                        );
                        this.activeModal.close(this.examSession);
                    } else {
                        this.toastr.error(
                            "Une erreur est survenue",
                            "Erreur"
                        );
                    }

                    this.submitting = false;
                    throw err;
                }
            );
    }

}
